import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { DialogComponent } from '../dialog.component';
import { FormControl, FormsModule } from '@angular/forms';
import { SelectComponent } from '../../../form/select/select.component';
import { TextareaComponent } from '../../../form/textarea/textarea.component';
import { Subject } from 'rxjs';
import { BaseDialog } from '@core/services/overlay/overlay.model';
import { TranslateModule } from '@ngx-translate/core';

export interface ConfirmConfig {
  titleKey?: string;
  submitLabelKey?: string;
  questionKey?: string;
  descriptionKey?: string;
  reason?: {
    control: FormControl;
    label?: string;
    description?: string;
    placeholder?: string;
  };
}

@Component({
  selector: 'hd-confirm-dialog',
  standalone: true,
  imports: [
    DialogComponent,
    FormsModule,
    SelectComponent,
    TextareaComponent,
    TranslateModule,
  ],
  templateUrl: './confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'relative' },
})
export class ConfirmDialogComponent implements BaseDialog, OnDestroy {
  @Input({ required: true }) config!: ConfirmConfig;
  @Output() closeRequested = new EventEmitter();
  @Output() submittedSuccessfully: EventEmitter<void> = new EventEmitter();

  public componentDestroyed: Subject<void> = new Subject();

  ngOnDestroy() {
    this.componentDestroyed.next();
    this.componentDestroyed.complete();
  }

  protected readonly removeEventListener = removeEventListener;
}
